import { merge } from 'lodash'
import { paymentform, TYPES as PAYMENT_FORM_TYPES } from './payment-form/store'

const store = {
  GENERIC: {
    namespaced: true,
    modules: {
      payment: {
        namespaced: true,
        modules: {
          paymentform
        }
      }
    }
  }
}

const TYPES = () =>
  merge(
    PAYMENT_FORM_TYPES
  )

export { store, TYPES }
